import { $lang } from '@msdk/common'
import { DateTimeValue, EMPTY_CELL_VALUE, FieldValue } from '@msdk/definitions'
import { Link, Typography, useComplatibleLocale, useRtlLocaleCheck } from '@msdk/ui'
import React from 'react'
import { useRecoilValue } from 'recoil'

import { Ellipsis } from './utils'

interface Props {
  clickable?: boolean
  onItemClick?: () => void
  value: FieldValue<unknown> | null
  ellipsis: boolean
  allowUnknown?: boolean
}

export function DateTimeCellRenderer({ clickable, onItemClick, value, ellipsis, allowUnknown }: Props) {
  const lang = useRecoilValue($lang)
  const compatibleLocale = useComplatibleLocale(lang)
  const isRtl = useRtlLocaleCheck(lang)
  const TypographyComponent = ellipsis ? Ellipsis : Typography

  const dateTimeValue = value as DateTimeValue | undefined

  if (dateTimeValue && clickable) {
    return (
      <TypographyComponent dir={isRtl ? 'rtl' : undefined} variant="body1">
        <Link underline="hover" onClick={onItemClick}>
          {dateTimeValue.toStringForView(compatibleLocale, allowUnknown)}
        </Link>
      </TypographyComponent>
    )
  }

  return (
    <TypographyComponent dir={isRtl ? 'rtl' : undefined} variant="body1">
      {dateTimeValue ? dateTimeValue.toStringForView(compatibleLocale, allowUnknown) : EMPTY_CELL_VALUE}
    </TypographyComponent>
  )
}
